import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useIntl } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration, { draftSlug } from '../../routing/routeConfiguration';
import css from './LandingPage.module.css';
import shape1 from '../../assets/how-it-work1.png';
import shape2 from '../../assets/how-it-work2.png';
import shape3 from '../../assets/how-it-work3.png';
import shape4 from '../../assets/how-it-work4.png';
import { getBlogData } from '../../util/dataExtractors';
import { markdownToPlainText } from '../../util/markdownHelpers';
import { createSlug } from '../../util/urlHelpers';
import Icons from '../../components/Icons/Icons';

const howItWorkImages = [shape1, shape2, shape3, shape4];

function SectionBlogs({ blogs, onRedirectToPage = () => {} }) {
  const intl = useIntl();
  const history = useHistory();
  const title = intl.formatMessage({ id: 'SectionBlogs.title' });
  const readArticle = intl.formatMessage({ id: 'SectionBlogs.readArticle' });
  const viewAll = intl.formatMessage({ id: 'SectionBlogs.viewAll' });

  const redirectToPage = (page, params = {}) =>
    history.push(createResourceLocatorString(page, routeConfiguration(), params, {}));

  return (
    <div className={css.blogSection}>
      <div className={css.aboutContent}>
        <div className={css.contentWidth}>
          <h2 dangerouslySetInnerHTML={{ __html: title }} />
          <div className={css.howItWorks}>
            {blogs.map((block, index) => {
              const { title = '', image, slug, description = '' } = getBlogData(block) || {};
              const descriptionContent = markdownToPlainText(description);

              return (
                <div
                  key={index}
                  className={css.workBlock}
                  role="button"
                  tabIndex={0}
                  onClick={() =>
                    redirectToPage('SingleBlogPage', {
                      id: block?.id,
                      slug: createSlug(slug || draftSlug),
                    })
                  }
                >
                  <div className={css.upperElement}>
                    <div className={css.workImg}>
                      <img src={image} alt={title} />
                    </div>
                    <div className={css.cardBody}>
                      <h2>{title}</h2>
                      {descriptionContent ? (
                        <p className={css.blogDescription}>{descriptionContent}</p>
                      ) : null}
                    </div>
                    <div className={css.cardFooter}>
                      <div className={css.readmore}>
                        {readArticle} <Icons name="rightAngle" />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={css.viewAllArticles}
            role="button"
            tabIndex={0}
            onClick={() => onRedirectToPage('BlogPage')}
          >
            {viewAll} <Icons name="rightAngle" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionBlogs;
